
<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
  export default {
    name: "App",
    data() {
      return {
        authTransferProcessed: false
      }
    },
    created() {
      // Check for auth transfer early in lifecycle
      this.checkAuthTransfer();
    },
    methods: {
      checkAuthTransfer() {
        // Prevent running twice
        if (this.authTransferProcessed) {
          return;
        }

        const hash = window.location.hash;

        if (hash && hash.includes('auth=')) {
          this.authTransferProcessed = true;

          try {
            // Extract encoded data from hash
            let encodedData = hash.split('auth=')[1];

            // Remove # if present
            if (encodedData.startsWith('#')) {
              encodedData = encodedData.substring(1);
            }

            // Split on & to handle potential query params
            encodedData = encodedData.split('&')[0];

            // Decode data
            const decodedData = JSON.parse(decodeURIComponent(atob(encodedData)));

            // Set all localStorage items in the correct order
            // Set critical authentication data first
            const criticalKeys = [
              'TOKEN', 'USER_ID', 'USER_EMAIL', 'domain', 'ENTITY_ID', 'entity_name',
              'USER_NAME', 'BRANCH_ID', 'IS_ADMIN', 'is_boardpage', 'is_family_book'
            ];

            criticalKeys.forEach(key => {
              if (decodedData[key] !== null && decodedData[key] !== undefined) {
                localStorage.setItem(key, decodedData[key]);
              }
            });

            // Then set all other data
            Object.keys(decodedData).forEach(key => {
              if (!criticalKeys.includes(key) && decodedData[key] !== null && decodedData[key] !== undefined) {
                localStorage.setItem(key, decodedData[key]);
              }
            });

            // Determine redirect path - use current pathname if it's a familybook path
            let redirectPath = '/';
            const currentPath = window.location.pathname;
            let family_office_flag = localStorage.getItem("family_office_flag");
            let family_tree_flag = localStorage.getItem("family_tree_flag");

            // console.log(family_office_flag ," family_office_flag  from old home");
            // console.log(family_tree_flag ," family_tree_flag  from old home");
            

            // if (currentPath.includes('/familybook/')) {
            //   // Already on a familybook page, keep the same path
            //   redirectPath = currentPath;
            // } else if (decodedData.is_family_book === 'true' || decodedData.is_family_book === true) {
            //   redirectPath = '/familybook/FamilyDashboard';
            // }

                        if (currentPath.includes('/familybook/')) {
                          // Already on a familybook page, keep the same path
                          redirectPath = currentPath;
                        } else if (decodedData.is_family_book === 'true' || decodedData.is_family_book === true) {
                          // Check family office and family tree flags to determine correct path
                          if (family_office_flag === 'true' || family_office_flag === true) {
                            redirectPath = '/familybook/Family_Forms';
                          } else if (family_tree_flag === 'true' || family_tree_flag === true) {
                            redirectPath = '/familybook/FamilyDashboard';
                          } else {
                            // Default to FamilyDashboard if no flags are set
                            redirectPath = '/familybook/FamilyDashboard';
                          }
                        }
                        

            // Clean up URL hash
            history.replaceState(null, null, redirectPath);

            // Reload page to apply all localStorage changes properly
            // Use replace to avoid back button issues
            window.location.replace(window.location.origin + redirectPath);
          } catch (error) {
            console.error('Error processing auth transfer:', error);
            alert('Error processing auth transfer: ' + error.message);
            // If transfer fails, redirect to login
            setTimeout(() => {
              window.location.href = '/login';
            }, 2000);
          }
        }
      }
    }
  }
</script>

<style>
/* #app, .login */
/* {
  margin-top: 30px;
} */
</style>